import { Typography, Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AttributeLine } from '../../RoadDataPopup/Content/styles';
import ExpandableImage from '../../Shared/ExpandableImage';
import { theme } from '../../../../../legacy/style/theme';
import { useAppSelector } from '../../../../../../types';
import { sessionByIdQuery } from '../../../../../../core/sessions/queries';
import { DegradationProperties } from '../../../../../../core/domain/map';

type Props = {
    properties: DegradationProperties;
};

const Content: FC<Props> = ({ properties }) => {
    const { t } = useTranslation();
    const session = useAppSelector(sessionByIdQuery(properties.sessionId));

    return (
        <Box marginBottom=".5rem">
            <Typography
                noWrap
                sx={{
                    wordBreak: 'break-all',
                    fontWeight: 600,
                    color: theme.color.black.main,
                }}
            >
                {session?.name}
            </Typography>
            {properties.imageIndex != null && (
                <ExpandableImage sessionId={properties.sessionId} imageIndex={properties.imageIndex} />
            )}
            <Box
                boxSizing="border-box"
                marginTop="-6px"
                padding="10px"
                color="white"
                width="100%"
                borderRadius="0 0 5px 5px"
                bgcolor={properties.color}
            >
                <AttributeLine label={t('map.popup.degradation_type')} value={properties.referenceName} />
            </Box>
        </Box>
    );
};

export default Content;
